var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"website-end"},[_c('p',[_vm._v(_vm._s(_vm.$t("互联网宗教信息服务许可证：浙（2025）0000313 版权声明： 2025-2028 极乐寺 ")))]),_c('p',[_vm._v(_vm._s(_vm.$t("（国家宗教事务局监制）")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }